module.exports = __webpack_public_path__ + "img/liveBroadcast-bg.8f6bd10e.png";